// KpiCard — single KPI tile for the dashboard-style stat row at the top of WeldAssure list pages.
// Mirrors the 4-up KPI row shown in the Figma PQR UI / WQTR UI mockups.
// CR-2026-WELDASSURE-UI-REFACTOR

import React from "react";
import { Card, Box, Typography } from "@mui/material";
import StatusPill from "./StatusPill";

export default function KpiCard({ label, value, sub, subKind = "neutral", sx = {} }) {
  return (
    <Card
      variant="outlined"
      sx={{
        p: 2,
        height: 84,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderColor: "#E8ECF0",
        ...sx,
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontSize: 11, fontWeight: 600, color: "#555F6B", letterSpacing: 0.3 }}
      >
        {label}
      </Typography>
      <Typography sx={{ fontSize: 24, fontWeight: 700, color: "#141A24", lineHeight: 1 }}>
        {value}
      </Typography>
      {sub && <StatusPill label={sub} kind={subKind} size="sm" />}
    </Card>
  );
}
